import { render } from "./AdPlacementTableItem.vue?vue&type=template&id=70741430"
import script from "./AdPlacementTableItem.vue?vue&type=script&lang=js"
export * from "./AdPlacementTableItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__